import React from "react";
import { Modal } from "react-bootstrap";
import '../App.css'

function Modal_Progress({
  backdrop=false, // true/false/static
  animation=true,
  show,
  onHide,
  centered=true,
  size='lg',
  progress
}) {


  return (
    <Modal
  backdrop={backdrop}
  animation={animation}
  show={show}
  onHide={onHide}
  centered={centered}
  className="loading-screen-transparent"
  fullscreen={true}
>
  <Modal.Body
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
        <h2>{progress.toFixed(2)}%</h2>
      <progress value={progress} max={100} />
  </Modal.Body>
</Modal>
  );
}

export default Modal_Progress;

